module.exports = __webpack_public_path__ + "img/logo-waybill.b882bdd0.png";